import React from "react";
import PropTypes from 'prop-types';
import cx from "classnames";
import CardListItem from '../CardListItem';
import qs from 'qs';
import {Link} from "react-router-dom";

class Card extends React.Component {
  _highlightHeading( cardHighlight = false ) {
    if ( cardHighlight) {
      return (
        <h3 className="cardHighlightHeading">Meest gekozen</h3>
      )
    }
  }

  _currentPlan() {
    const { currentPlan, plan, showCurrentPlan} = this.props;

    if (!showCurrentPlan || currentPlan !== plan ) {
      return null;
    }

    return (
      <h3 className="cardHighlightHeading">Huidige keuze</h3>
    )
  }

  _renderContentList() {
    const { cardContentList } = this.props;

    return (
      <ul className="cardContentList">
        {cardContentList.map((listItem, index) => {
          return (
            <CardListItem key={ index } highlightedText={ listItem.highlightedText } text={ listItem.text } info={ listItem.info }/>
          );
        })}
      </ul>
    );
  }

  constructor(props, context) {
    super(props, context);
    let initialState = {};
    if (typeof window !== 'undefined') {
      if (props.plan !== 'sandbox' && window.location.search !== '') {
        const query = qs.parse(window.location.search.substr(1));
        if (query.id) initialState.id = query.id;
      }
    }
    this.state = {
      submitting: false,
      values: Object.assign({
        plan: props.plan,
      }, initialState),
    };
  }

  _renderFooter(period) {
    const { onClick, plan } = this.props;

    if (typeof onClick === 'function' ) {
      return (
        <button type="button" className={ cx("button", "buttonCta", "buttonSmall") } onClick={() => onClick(plan, period)}>
          Kies dit pakket
        </button>
      );
    }

    return (
      <div>
        <Link className="button cardButton buttonCta buttonSmall" to={ `/registreren/?plan=${plan}&period=${period}` }>Registreer nu</Link>
      </div>
    );
  }

  render() {
    const { headerTitle, cardLight, cardHighlight, showPeriod, priceMonth, priceYear, priceMonthYear } = this.props;

    const classname = cx({
      "card": true,
      "cardHighlight": cardHighlight,
      "cardLight": cardLight
    });

    return (
      <div className={ classname }>
        <div className="cardContentWrapper">
          { this._highlightHeading( cardHighlight )}
          { this._currentPlan() }
          <div className="cardHeader">
            { headerTitle }
          </div>
            { showPeriod === 'month' && (
              <div className="cardPrice">
                <strong>{ priceMonth }</strong>
                <span>per maand</span>
              </div>
            )}
          { showPeriod === 'year' && (
            <div className="cardPriceWrapper">
              <div className="cardPrice">
                <strong>{ priceYear }</strong>
                <span>per jaar</span>
              </div>
              <div className="cardPriceMonthYear">
                <span>{priceMonthYear} per maand</span>
              </div>
            </div>
          )}
          <div className="cardContent">
            { this._renderContentList() }
          </div>
          <div className={"cardFooter"}>
            { this._renderFooter(showPeriod) }
          </div>
        </div>
      </div>
    )
  }
}

Card.propTypes = {
  children: PropTypes.node,
  showPeriod: PropTypes.string.isRequired,
  plan: PropTypes.string.isRequired,
  headerTitle: PropTypes.string.isRequired,
  cardHighlight: PropTypes.bool,
  cardContentList: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  context: PropTypes.string,
  currentPlan: PropTypes.string,
  qs: PropTypes.object,
  cardLight: PropTypes.bool,
  priceMonth: PropTypes.string.isRequired,
  priceYear: PropTypes.string.isRequired,
  priceMonthYear: PropTypes.string.isRequired,
  showCurrentPlan: PropTypes.bool,
  onClick: PropTypes.func
};

export default Card;
